import React from 'react';
import { motion } from 'framer-motion';

export const Terms = () => {
  return (
    <div className="min-h-screen py-16">
      <div className="container-custom max-w-4xl">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
        >
          <h1 className="font-serif text-5xl font-bold text-foreground mb-4">
            Terms & Conditions
          </h1>
          <p className="text-muted-foreground mb-8">Last updated: January 2026</p>

          <div className="prose prose-lg max-w-none space-y-8">
            <section>
              <h2 className="font-serif text-3xl font-semibold mb-4">Agreement to Terms</h2>
              <p className="text-muted-foreground leading-relaxed">
                By accessing and using NaturalCare's website and services, you agree to be bound by these Terms and Conditions. If you disagree with any part of these terms, you may not access our services.
              </p>
            </section>

            <section>
              <h2 className="font-serif text-3xl font-semibold mb-4">Use of Service</h2>
              <p className="text-muted-foreground leading-relaxed mb-4">
                You agree to use our services only for lawful purposes and in accordance with these Terms. You agree not to:
              </p>
              <ul className="list-disc pl-6 text-muted-foreground space-y-2">
                <li>Violate any applicable laws or regulations</li>
                <li>Infringe upon the rights of others</li>
                <li>Transmit any harmful or malicious code</li>
                <li>Attempt to gain unauthorized access to our systems</li>
              </ul>
            </section>

            <section>
              <h2 className="font-serif text-3xl font-semibold mb-4">Products and Services</h2>
              <p className="text-muted-foreground leading-relaxed">
                All products and services are subject to availability. We reserve the right to discontinue any product at any time. Prices are subject to change without notice.
              </p>
            </section>

            <section>
              <h2 className="font-serif text-3xl font-semibold mb-4">Orders and Payment</h2>
              <p className="text-muted-foreground leading-relaxed">
                By placing an order, you represent that you are legally capable of entering into binding contracts. We reserve the right to refuse any order. All orders are subject to product availability and confirmation of the order price.
              </p>
            </section>

            <section>
              <h2 className="font-serif text-3xl font-semibold mb-4">Shipping and Delivery</h2>
              <p className="text-muted-foreground leading-relaxed">
                We will make every effort to deliver products within the estimated timeframe. However, delivery times are not guaranteed and may be affected by factors beyond our control.
              </p>
            </section>

            <section>
              <h2 className="font-serif text-3xl font-semibold mb-4">Returns and Refunds</h2>
              <p className="text-muted-foreground leading-relaxed">
                We accept returns of unopened products within 30 days of delivery. Refunds will be processed within 7-10 business days of receiving the returned product.
              </p>
            </section>

            <section>
              <h2 className="font-serif text-3xl font-semibold mb-4">Limitation of Liability</h2>
              <p className="text-muted-foreground leading-relaxed">
                NaturalCare shall not be liable for any indirect, incidental, special, consequential, or punitive damages resulting from your use of our services.
              </p>
            </section>

            <section>
              <h2 className="font-serif text-3xl font-semibold mb-4">Changes to Terms</h2>
              <p className="text-muted-foreground leading-relaxed">
                We reserve the right to modify these terms at any time. Continued use of our services after changes constitutes acceptance of the modified terms.
              </p>
            </section>

            <section>
              <h2 className="font-serif text-3xl font-semibold mb-4">Contact Information</h2>
              <p className="text-muted-foreground leading-relaxed">
                For questions about these Terms, contact us at:
                <br />
                <a href="mailto:legal@naturalcare.com" className="text-primary hover:underline">
                  legal@naturalcare.com
                </a>
              </p>
            </section>
          </div>
        </motion.div>
      </div>
    </div>
  );
};